import { useEventListener } from "@vueuse/core";

function detail(event) {
  return event.detail?.[0];
}

/**
 * Runs the finder's result commands for the events the result cards inside `container` send.
 * Card events do not bubble, so one capturing listener per event serves every card, a slideshow's clones included.
 */
export function useResultEvents(container, commands) {
  function run(name, argument) {
    return commands()[name]?.(argument);
  }

  function handleAddFilters(event) {
    run("addFilters", detail(event));
  }

  function handleShowMap(event) {
    run("showOnMap", detail(event)?.resultGuid ?? event.target.dataset?.resultGuid);
  }

  function handlePlayVideo(event) {
    run("playVideo", detail(event));
  }

  function handleShowMoreSlots(event) {
    run("showMoreSlots", detail(event));
  }

  function handleShowDate(event) {
    run("showDate", detail(event));
  }

  const options = { capture: true };
  useEventListener(container, "add-filters", handleAddFilters, options);
  useEventListener(container, "show-map", handleShowMap, options);
  useEventListener(container, "play-video", handlePlayVideo, options);
  useEventListener(container, "show-more-slots", handleShowMoreSlots, options);
  useEventListener(container, "show-date", handleShowDate, options);
}
